import React from "react";
import { Helmet } from "react-helmet";
import { Route, Switch } from "react-router-dom";

import ErrorBoundary from "@components/ErrorBoundary";
import WebFormPublicView from "@containers/Settings/Automation/WebForm/WebFormPublicView";
import PageNotFound from "@containers/PageLayout/PageNotFound";

import PublicRoute from "../containers/App/PublicRoute";

function WebformRoute(): JSX.Element {
	return (
		<React.Fragment>
			<Helmet
				titleTemplate="%s - Pepper Cloud CRM"
				defaultTitle="Pepper Cloud CRM"
			>
				<meta name="description" content="Simple CRM for Smart People" />
			</Helmet>
			<ErrorBoundary>
				<Switch>
					<Route exact path="/form/:formId" component={WebFormPublicView} />
					<Route
						exact
						path="/form/:formId/embed"
						component={WebFormPublicView}
					/>

					<PublicRoute path="*" component={PageNotFound} />
				</Switch>
			</ErrorBoundary>
		</React.Fragment>
	);
}

export default WebformRoute;
